// Placeholder для разделов, которые видны в shell, но не являются проверяемым
// результатом текущего инкремента.
//
// Каждая страница оформлена однотипно: заголовок раздела + краткое описание +
// EmptyState с указанием шага roadmap'а, на котором страница «оживёт». Это —
// визуальный аналог "in progress" из roadmap'а: маршрут кликабелен и не
// имитирует готовый экран.

import type { ReactNode } from 'react'
import { EmptyState, Surface } from '@frm/ui'

export interface PagePlaceholderProps {
  title: string
  description?: ReactNode
  /** Например, "Шаг 4 / Фаза 2" — куда смотреть в roadmap'е спринта. */
  roadmapStep?: string
}

export function PagePlaceholder({ title, description, roadmapStep }: PagePlaceholderProps) {
  return (
    <Surface
      variant="default"
      padding="lg"
      style={{
        display: 'grid',
        gap: 20,
      }}
    >
      <header style={{ display: 'grid', gap: 6 }}>
        <h1
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 800,
            letterSpacing: '-0.01em',
            color: 'var(--frm-text, #F8FAFC)',
          }}
        >
          {title}
        </h1>
        {description ? (
          <p
            style={{
              margin: 0,
              color: 'var(--frm-text-muted, #9AA8BC)',
              fontSize: 13,
              lineHeight: 1.5,
            }}
          >
            {description}
          </p>
        ) : null}
      </header>
      <EmptyState
        title="Раздел в разработке"
        description={
          roadmapStep
            ? `Каркас экрана появится на этапе: ${roadmapStep}. Сейчас закрыт Шаг 1 спринта ai-agents-new-frontend (новый frontend-каркас).`
            : 'Содержимое раздела появится в отдельном следующем шаге или спринте.'
        }
      />
    </Surface>
  )
}
